// step names in the signup flow
export enum SignupStep {
  CREATE_ACCOUNT = 'account',
  SHIPPING_ADDRESS = 'address',
  PAYMENT = 'payment'
}
